export default "__VITE_ASSET__rCRI5Qmr__"